export const HELICOPTER_DATA_IMPORT_REQUEST = 'HELICOPTER_DATA_IMPORT_REQUEST';
export const HELICOPTER_DATA_IMPORT_SUCCESS = 'HELICOPTER_DATA_IMPORT_SUCCESS';
export const HELICOPTER_DATA_IMPORT_ERROR = 'HELICOPTER_DATA_IMPORT_ERROR';

export const importHelicopterData = (csv_file) => {
    return {
        type: 'CALL_API',
        types: [HELICOPTER_DATA_IMPORT_REQUEST, HELICOPTER_DATA_IMPORT_SUCCESS, HELICOPTER_DATA_IMPORT_ERROR],
        path: `api/import`,
        method: 'post',
        payload: {
            csv_file
        },
        message: 'Your import has been scheduled',
        redirect: () => {
            return `/admin/jobs`;
        }
    };
};


// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/helicopterData.js